import { isAddressWeth } from '@/domain/ticks/helpers';
import { NonfungiblePositionManager } from '@nftx/abi';
import {
  Address,
  LiquidityPool,
  LiquidityPosition,
  NONFUNGIBLE_POSITION_MANAGER,
  Provider,
  Signer,
  config,
  getChainConstant,
  getContract,
  increaseByPercentage,
} from 'nftx.js';

const claimLpRewards = ({
  network = config.network,
  provider,
  signer,
  pool: {
    tokens: [{ id: token0 }],
  },
  position: { claimableEth, claimableVToken, tokenId, manager },
  userAddress,
  slippagePercentage,
}: {
  network?: number;
  provider: Provider;
  signer: Signer;
  pool: {
    vaultId: LiquidityPool['vaultId'];
    tokens: { id: LiquidityPool['tokens'][0]['id'] }[];
  };
  position: Pick<
    LiquidityPosition,
    'claimableEth' | 'claimableVToken' | 'tokenId' | 'manager'
  >;
  userAddress: Address;
  slippagePercentage?: number;
}) => {
  const contract = getContract({
    abi: NonfungiblePositionManager,
    address: manager || getChainConstant(NONFUNGIBLE_POSITION_MANAGER, network),
    provider,
    signer,
  });

  const isToken0Weth = isAddressWeth(token0, network);
  const amount0 = isToken0Weth ? claimableEth : claimableVToken;
  const amount1 = isToken0Weth ? claimableVToken : claimableEth;
  const amount0Max = increaseByPercentage(amount0, slippagePercentage);
  const amount1Max = increaseByPercentage(amount1, slippagePercentage);

  return contract.write.collect({
    args: [
      {
        amount0Max,
        amount1Max,
        recipient: userAddress,
        tokenId: BigInt(tokenId),
      },
    ],
  });
};

export default claimLpRewards;
